import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
});

// Add debugging to see what URL is being used
console.log('API Base URL:', process.env.REACT_APP_API_URL || 'http://localhost:3001');

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    // Skip adding token for health and login endpoints
    if (config.url?.includes('/health') || config.url?.includes('/auth/login')) {
      return config;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('API Error:', error.response?.status, error.response?.statusText, error.config?.url)
    if (error.response?.status === 401) {
      console.log('401 Unauthorized error detected')
      // Handle unauthorized access
      localStorage.removeItem('token');
      // Only redirect if not already on login page to prevent infinite loops
      if (window.location.pathname !== '/login') {
        console.log('Redirecting to login page')
        window.location.href = '/login';
      } else {
        console.log('Already on login page, not redirecting')
      }
    }
    return Promise.reject(error);
  }
);

export default api; 